import { Container } from 'pixi.js';

import { Shared } from '../../App';
import { BillboardArrow } from './BillboardArrow';

export class BillboardKeys extends Container
{
    public up: BillboardArrow;
    public down: BillboardArrow;
    public left: BillboardArrow;
    public right: BillboardArrow;

    constructor()
    {
        super();
        this.up = new BillboardArrow();
        this.addChild(this.up);
        this.up.y = -this.up.height * 0.5;

        this.down = new BillboardArrow();
        this.addChild(this.down);
        this.down.y = -this.up.y;
        this.down.rotation = Math.PI;

        this.right = new BillboardArrow();
        this.addChild(this.right);
        this.right.x = this.right.width * 0.92;
        this.right.y = this.down.y;
        this.right.rotation = Math.PI * 0.5;

        this.left = new BillboardArrow();
        this.addChild(this.left);
        this.left.x = -this.right.x;
        this.left.y = this.down.y;
        this.left.rotation = -Math.PI * 0.5;
    }

    public update(): void
    {
        const acc = Shared.game.vehicle.motor.acceleration;
        const lean = Shared.game.vehicle.motor.lean;

        acc > 0 ? this.up.press() : this.up.release();
        acc < 0 ? this.down.press() : this.down.release();
        lean > 0 ? this.left.press() : this.left.release();
        lean < 0 ? this.right.press() : this.right.release();
    }
}
